import { Injectable } from '@angular/core';
import { DemarcatorRange, TimelineShift } from '@wilson/interfaces';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class AssignmentsDragDropHelperService {
  private demarcatorRangeSubject = new BehaviorSubject<DemarcatorRange | null>(
    null,
  );
  private draggingShiftSubject = new BehaviorSubject<TimelineShift | null>(
    null,
  );

  demarcatorRange$ = this.demarcatorRangeSubject.asObservable();
  draggingShift$ = this.draggingShiftSubject.asObservable();

  setDemarcatorRange(demarcatorRange: DemarcatorRange | null): void {
    this.demarcatorRangeSubject.next(demarcatorRange);
  }

  setDraggingShift(shift: TimelineShift | null): void {
    this.draggingShiftSubject.next(shift);
  }
}
